import React, { useState } from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  Avatar,
  Box,
  Tooltip,
  Divider,
  Typography,
} from "@mui/material";

import {
  ExpandLess,
  ExpandMore,
  Home,
  Business,
  Store,
  People,
  Security,
  BarChart,
  PeopleOutline,
  PeopleTwoTone,
  Diversity3,
  PinDrop,
  Source,
  AccountBalance,
  LocalShipping,
  AdminPanelSettings,
  Article,
} from "@mui/icons-material";
import { NavLink } from "react-router-dom";
import ArticleIcon from '@mui/icons-material/Article';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PaymentsIcon from '@mui/icons-material/Payments';

//---------------- Auth---------------- 
import { AuthProvider, useAuth } from "./AuthContext";

const Sidebar = ({ open }) => {
  const [masterOpen, setMasterOpen] = useState(false);
  const [tranascationOpen, setTransactionOpen] = useState(false);
  const [accountsOpen, setAccountsOpen] = useState(false);
  const [userOpen, setUserOpen] = useState(false);
  const [reportOpen, setReportOpen] = useState(false);

  const [subMenuOpen, setSubMenuOpen] = useState({
    purchase: false,
    sale: false,
    stocks: false,
    Accounts: false,
  });

  const toggleSubMenu = (menu) => {
    setSubMenuOpen((prev) => ({
      ...prev,
      [menu]: !prev[menu],
    }));
  };
  const { companyName, companyId, isSuperAdmin, superCompanyId, permissions, roleName } = useAuth();

  {/* Permissions */ }
  const hasReadMasterPermission = permissions.includes('Read Master');
  const hasReadTransactionPermission = permissions.includes('Read Transaction');
  const hasReadAccountsPermission = permissions.includes('Read Accounts');
  const hasReadAdministrationPermission = permissions.includes('Read Administration');
  const hasReadReadReportsPermission = permissions.includes('Read Reports');

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: open ? 240 : 60,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: open ? 240 : 60,
          background: "linear-gradient(180deg, #34332f 0%, #34332f 100%)",
          color: "white",
          overflowX: "hidden",
          transition: "width 0.3s ease",
          borderRight: "none",
          position: "fixed",
          height: "100vh",
          zIndex: 1200,
        },
      }}
    >
      {/* Profile */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          p: 2,
          justifyContent: open ? "flex-start" : "center",
        }}
      >
        {open && (
          <Box>

          </Box>
        )}
      </Box>
      <Divider sx={{ bgcolor: "rgba(255,255,255,0.2)" }} />

      <List style={{ marginTop: '20px' }}>
        {/* Home */}
        <Tooltip title="Home" placement="right" disableHoverListener={open}>
          <ListItemButton
            component={NavLink}
            to="/Home"
            sx={{
              "&.active": {
                bgcolor: "rgba(255,255,255,0.1)",
                borderLeft: "4px solid #4CAF50",
              },
            }}
          >
            <ListItemIcon>
              <Home sx={{ color: "whitesmoke" }} />
            </ListItemIcon>
            {open &&
              <ListItemText primary="Home"
                primaryTypographyProps={{
                  style: {
                    cursor: 'pointer',
                    fontFamily: '"brandon-grotesque-n7", "brandon-grotesque", sans-serif',
                    fontSize: '14px',
                    fontWeight: 'bold',
                  },
                }}
              />}
          </ListItemButton>
        </Tooltip>

        {/* Master Section */}
        {hasReadMasterPermission && (
          <ListItemButton onClick={() => setMasterOpen(!masterOpen)}>
            <ListItemIcon>
              <Business sx={{ color: "whitesmoke" }} />
            </ListItemIcon>
            {open &&
              <ListItemText primary="Master"
                primaryTypographyProps={{
                  style: {
                    cursor: 'pointer',
                    fontFamily: '"brandon-grotesque-n7", "brandon-grotesque", sans-serif',
                    fontSize: '14px',
                    fontWeight: 'bold',
                  },
                }}
              />}

            {open && (masterOpen ? <ExpandLess /> : <ExpandMore />)}
          </ListItemButton>
        )}

        <Collapse in={masterOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItemButton
              component={NavLink}
              to="/CompanyEdit"
              sx={{
                pl: open ? 4 : 2,
                "&.active": {
                  bgcolor: "rgba(255,255,255,0.15)",
                  borderLeft: "4px solid #2196F3",
                },
              }}
            >
              {open &&
                < ListItemText primary="Company"
                  primaryTypographyProps={{
                    style: {
                      marginLeft: '55px',
                      fontFamily: 'monospace',
                      fontSize: '14px'
                    },
                  }} />}
            </ListItemButton>
            <ListItemButton
              component={NavLink}
              to="/BalanceSheetIndex"
              sx={{
                pl: open ? 4 : 2,
                "&.active": {
                  bgcolor: "rgba(255,255,255,0.15)",
                  borderLeft: "4px solid #FF9800",
                },
              }}
            >
              {open &&
                <ListItemText primary="Balance Sheet"
                  primaryTypographyProps={{
                    style: {
                      marginLeft: '55px',
                      fontFamily: 'monospace',
                      fontSize: '14px'
                    },
                  }} />}
            </ListItemButton>

            <ListItemButton
              component={NavLink}
              to="/MasterIndex"
              sx={{
                pl: open ? 4 : 2,
                "&.active": {
                  bgcolor: "rgba(255,255,255,0.15)",
                  borderLeft: "4px solid #009688",
                },
              }}
            >
              {open &&
                < ListItemText primary="Registration"
                  primaryTypographyProps={{
                    style: {
                      marginLeft: '55px',
                      fontFamily: 'monospace',
                      fontSize: '14px'
                    },
                  }} />}
            </ListItemButton>

            <ListItemButton
              component={NavLink}
              to="/CategoryIndex"
              sx={{
                pl: open ? 4 : 2,
                "&.active": {
                  bgcolor: "rgba(255,255,255,0.15)",
                  borderLeft: "4px solid #8BC34A",
                },
              }}
            >
              {open &&
                < ListItemText primary="Category"
                  primaryTypographyProps={{
                    style: {
                      marginLeft: '55px',
                      fontFamily: 'monospace',
                      fontSize: '14px'
                    },
                  }} />}
            </ListItemButton>

            <ListItemButton
              component={NavLink}
              to="/ItemIndex"
              sx={{
                pl: open ? 4 : 2,
                "&.active": {
                  bgcolor: "rgba(255,255,255,0.15)",
                  borderLeft: "4px solid #8BC34A",
                },
              }}
            >
              {open &&
                < ListItemText primary="Item"
                  primaryTypographyProps={{
                    style: {
                      marginLeft: '55px',
                      fontFamily: 'monospace',
                      fontSize: '14px'
                    },
                  }} />}
            </ListItemButton>

          </List>
        </Collapse>

        {hasReadMasterPermission && (
          <ListItemButton onClick={() => setTransactionOpen(!tranascationOpen)}>
            <ListItemIcon>
              <AccountBalanceIcon sx={{ color: "whitesmoke" }} />
            </ListItemIcon>
            {open &&
              <ListItemText primary="Transaction"
                primaryTypographyProps={{
                  style: {
                    cursor: 'pointer',
                    fontFamily: '"brandon-grotesque-n7", "brandon-grotesque", sans-serif',
                    fontSize: '14px',
                    fontWeight: 'bold',
                  },
                }}
              />}

            {open && (tranascationOpen ? <ExpandLess /> : <ExpandMore />)}
          </ListItemButton>
        )}

        <Collapse in={tranascationOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItemButton
              component={NavLink}
              to="/PurchaseIndex"
              sx={{
                pl: open ? 4 : 2,
                "&.active": {
                  bgcolor: "rgba(255,255,255,0.15)",
                  borderLeft: "4px solid #FF9800",
                },
              }}
            >
              {open &&
                <ListItemText primary="Purchase"
                  primaryTypographyProps={{
                    style: {
                      marginLeft: '55px',
                      fontFamily: 'monospace',
                      fontSize: '14px'
                    },
                  }} />}
            </ListItemButton>

            <ListItemButton
              component={NavLink}
              to="/PurchaseReturnIndex"
              sx={{
                pl: open ? 4 : 2,
                "&.active": {
                  bgcolor: "rgba(255,255,255,0.15)",
                  borderLeft: "4px solid #F44336",
                },
              }}
            >
              {open &&
                < ListItemText primary="Purchase Return"
                  primaryTypographyProps={{
                    style: {
                      marginLeft: '55px',
                      fontFamily: 'monospace',
                      fontSize: '14px'
                    },
                  }} />}
            </ListItemButton>

            <ListItemButton
              component={NavLink}
              to="/ProformaIndex"
              sx={{
                pl: open ? 4 : 2,
                "&.active": {
                  bgcolor: "rgba(255,255,255,0.15)",
                  borderLeft: "4px solid #8BC34A",
                },
              }}
            >
              {open &&
                < ListItemText primary="Proforma"
                  primaryTypographyProps={{
                    style: {
                      marginLeft: '55px',
                      fontFamily: 'monospace',
                      fontSize: '14px'
                    },
                  }} />}
            </ListItemButton>

            <ListItemButton
              component={NavLink}
              to="/SaleIndex"
              sx={{
                pl: open ? 4 : 2,
                "&.active": {
                  bgcolor: "rgba(255,255,255,0.15)",
                  borderLeft: "4px solid #8BC34A",
                },
              }}
            >
              {open &&
                < ListItemText primary="Sale"
                  primaryTypographyProps={{
                    style: {
                      marginLeft: '55px',
                      fontFamily: 'monospace',
                      fontSize: '14px'
                    },
                  }} />}
            </ListItemButton>

            <ListItemButton
              component={NavLink}
              to="/SaleReturnIndex"
              sx={{
                pl: open ? 4 : 2,
                "&.active": {
                  bgcolor: "rgba(255,255,255,0.15)",
                  borderLeft: "4px solid #8BC34A",
                },
              }}
            >
              {open &&
                < ListItemText primary="Sale Return"
                  primaryTypographyProps={{
                    style: {
                      marginLeft: '55px',
                      fontFamily: 'monospace',
                      fontSize: '14px'
                    },
                  }} />}
            </ListItemButton>

            <ListItemButton
              component={NavLink}
              to="/StockJournalIndex"
              sx={{
                pl: open ? 4 : 2,
                "&.active": {
                  bgcolor: "rgba(255,255,255,0.15)",
                  borderLeft: "4px solid #8BC34A",
                },
              }}
            >
              {open &&
                < ListItemText primary="Stock Journal"
                  primaryTypographyProps={{
                    style: {
                      marginLeft: '55px',
                      fontFamily: 'monospace',
                      fontSize: '14px'
                    },
                  }} />}
            </ListItemButton>
          </List>
        </Collapse>

        {hasReadAccountsPermission && (
          <ListItemButton onClick={() => setAccountsOpen(!accountsOpen)}>
            <ListItemIcon>
              <AccountBalanceWalletIcon sx={{ color: "whitesmoke" }} />
            </ListItemIcon>
            {open &&
              <ListItemText primary="Accounts"
                primaryTypographyProps={{
                  style: {
                    cursor: 'pointer',
                    fontFamily: '"brandon-grotesque-n7", "brandon-grotesque", sans-serif',
                    fontSize: '14px',
                    fontWeight: 'bold',
                  },
                }}
              />}

            {open && (accountsOpen ? <ExpandLess /> : <ExpandMore />)}
          </ListItemButton>
        )}

        <Collapse in={accountsOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItemButton
              component={NavLink}
              to="/JournelEntryIndex"
              sx={{
                pl: open ? 4 : 2,
                "&.active": {
                  bgcolor: "rgba(255,255,255,0.15)",
                  borderLeft: "4px solid #2196F3",
                },
              }}
            >
              {open &&
                < ListItemText primary="Journal Entry"
                  primaryTypographyProps={{
                    style: {
                      marginLeft: '35px',
                      fontFamily: 'monospace',
                      fontSize: '14px'
                    },
                  }} />}
            </ListItemButton>

            <ListItemButton
              component={NavLink}
              to="/IncomeExpenseIndex"
              sx={{
                pl: open ? 4 : 2,
                "&.active": {
                  bgcolor: "rgba(255,255,255,0.15)",
                  borderLeft: "4px solid #FF9800",
                },
              }}
            >
              {open &&
                <ListItemText primary="Income & Expense"
                  primaryTypographyProps={{
                    style: {
                      marginLeft: '35px',
                      fontFamily: 'monospace',
                      fontSize: '14px'
                    },
                  }} />}
            </ListItemButton>

            <ListItemButton
              component={NavLink}
              to="/PaymentIndex"
              sx={{
                pl: open ? 4 : 2,
                "&.active": {
                  bgcolor: "rgba(255,255,255,0.15)",
                  borderLeft: "4px solid #F44336",
                },
              }}
            >
              {open &&
                < ListItemText primary="Purchase Payment"
                  primaryTypographyProps={{
                    style: {
                      marginLeft: '35px',
                      fontFamily: 'monospace',
                      fontSize: '14px'
                    },
                  }} />}
            </ListItemButton>

            <ListItemButton
              component={NavLink}
              to="/ReceiptIndex"
              sx={{
                pl: open ? 4 : 2,
                "&.active": {
                  bgcolor: "rgba(255,255,255,0.15)",
                  borderLeft: "4px solid #009688",
                },
              }}
            >
              {open &&
                < ListItemText primary="Sale Receipt"
                  primaryTypographyProps={{
                    style: {
                      marginLeft: '35px',
                      fontFamily: 'monospace',
                      fontSize: '14px'
                    },
                  }} />}
            </ListItemButton>

            <ListItemButton
              component={NavLink}
              to="/PaymentAndReceiptIndex"
              sx={{
                pl: open ? 4 : 2,
                "&.active": {
                  bgcolor: "rgba(255,255,255,0.15)",
                  borderLeft: "4px solid #8BC34A",
                },
              }}
            >
              {open &&
                < ListItemText primary="Payment & Receipt"
                  primaryTypographyProps={{
                    style: {
                      marginLeft: '35px',
                      fontFamily: 'monospace',
                      fontSize: '14px'
                    },
                  }} />}
            </ListItemButton>

          </List>
        </Collapse>

        {hasReadAdministrationPermission && (
          <ListItemButton onClick={() => setUserOpen(!userOpen)}>
            <ListItemIcon>
              <People sx={{ color: "whitesmoke" }} />
            </ListItemIcon>
            {open &&
              <ListItemText primary="Auth Zen"
                primaryTypographyProps={{
                  style: {
                    cursor: 'pointer',
                    fontFamily: '"brandon-grotesque-n7", "brandon-grotesque", sans-serif',
                    fontSize: '14px',
                    fontWeight: 'bold',
                  },
                }}
              />}
            {open && (userOpen ? <ExpandLess /> : <ExpandMore />)}
          </ListItemButton>

        )}

        <Collapse in={userOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItemButton
              component={NavLink}
              to="/UserIndex"
              sx={{
                pl: open ? 4 : 2,
                "&.active": {
                  bgcolor: "rgba(255,255,255,0.15)",
                  borderLeft: "4px solid orange",

                },
              }}
            >
              {open &&
                < ListItemText primary="Users"
                  primaryTypographyProps={{
                    style: {
                      marginLeft: '55px',
                      fontFamily: 'monospace',
                      fontSize: '14px'
                    },
                  }} />}
            </ListItemButton>

            <ListItemButton
              component={NavLink}
              to="/RoleIndex"
              sx={{
                pl: open ? 4 : 2,
                "&.active": {
                  bgcolor: "rgba(255,255,255,0.15)",
                  borderLeft: "4px solid #FF9800",
                },
              }}
            >
              {open &&
                < ListItemText primary="Roles"
                  primaryTypographyProps={{
                    style: {
                      marginLeft: '55px',
                      fontFamily: 'monospace',
                      fontSize: '14px'
                    },
                  }} />}
            </ListItemButton>

            <ListItemButton
              component={NavLink}
              to="/PasswordChange"
              sx={{
                pl: open ? 4 : 2,
                "&.active": {
                  bgcolor: "rgba(255,255,255,0.15)",
                  borderLeft: "4px solid green",
                },
              }}
            >
              {open &&
                < ListItemText primary="Reset Password"
                  primaryTypographyProps={{
                    style: {
                      marginLeft: '55px',
                      fontFamily: 'monospace',
                      fontSize: '14px'
                    },
                  }} />}
            </ListItemButton>
          </List>
        </Collapse>

        {hasReadReadReportsPermission && (
          <>
            <ListItemButton onClick={() => setReportOpen(!reportOpen)}>
              <ListItemIcon>
                <BarChart sx={{ color: "whitesmoke" }} />
              </ListItemIcon>
              {open && (
                <ListItemText
                  primary="Reports"
                  primaryTypographyProps={{
                    style: {
                      cursor: "pointer",
                      fontFamily: '"brandon-grotesque-n7", "brandon-grotesque", sans-serif',
                      fontSize: "14px",
                      fontWeight: "bold",
                    },
                  }}
                />
              )}
              {open && (reportOpen ? <ExpandLess /> : <ExpandMore />)}
            </ListItemButton>

            <Collapse in={reportOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {/* Purchase */}
                <ListItemButton
                  onClick={() => toggleSubMenu("purchase")}
                  sx={{
                    pl: open ? 4 : 2,
                    bgcolor: subMenuOpen.purchase ? "rgba(255,165,0,0.15)" : "transparent",
                    "&:hover": { bgcolor: "rgba(255,165,0,0.25)" },
                  }}
                >
                  <ListItemIcon>
                    <ShoppingCartIcon sx={{ color: "whitesmoke", marginLeft: "20px", fontSize: '19px' }} />
                  </ListItemIcon>

                  {open && (
                    <ListItemText
                      primary="Purchase"
                      primaryTypographyProps={{
                        style: {
                          fontFamily: "monospace",
                          fontSize: "14px",
                          fontWeight: "bold",
                          marginLeft: "10px", // keep icon + text spacing clean
                          color: "whitesmoke", // text stays whitesmoke
                        },
                      }}
                    />
                  )}
                  {open && (subMenuOpen.purchase ? <ExpandLess /> : <ExpandMore />)}
                </ListItemButton>

                <Collapse in={subMenuOpen.purchase} timeout="auto" unmountOnExit style={{ backgroundColor: 'rgba(255,165,0,0.25)' }}>
                  <List component="div" disablePadding>
                    <ListItemButton component={NavLink} to="/PurchaseRegisterReport" sx={{ pl: 6, "&:hover": { bgcolor: "rgba(255,165,0,0.2)" } }}>
                      <ListItemText primary="Purchase Register" primaryTypographyProps={{ style: { fontSize: "13px", fontFamily: "monospace", color: "whitesmoke", marginLeft: "5px" } }} />
                    </ListItemButton>
                    <ListItemButton component={NavLink} to="/PurchasePartyandItemWiseReport" sx={{ pl: 6, "&:hover": { bgcolor: "rgba(255,165,0,0.2)" } }}>
                      <ListItemText primary="Purchase Report" primaryTypographyProps={{ style: { fontSize: "13px", fontFamily: "monospace", color: "whitesmoke", marginLeft: "5px" } }} />
                    </ListItemButton>
                  </List>
                </Collapse>

                {/* Sales */}
                <ListItemButton
                  onClick={() => toggleSubMenu("sale")}
                  sx={{
                    pl: open ? 4 : 2,
                    bgcolor: subMenuOpen.sale ? "rgba(76,175,80,0.15)" : "transparent",
                    "&:hover": { bgcolor: "rgba(76,175,80,0.25)" },
                  }}
                >
                  <ListItemIcon>
                    <ShoppingBasketIcon sx={{ color: "whitesmoke", marginLeft: "20px", fontSize: '19px' }} />
                  </ListItemIcon>

                  {open && (
                    <ListItemText
                      primary="Sales"
                      primaryTypographyProps={{
                        style: {
                          fontFamily: "monospace",
                          fontSize: "14px",
                          fontWeight: "bold",
                          marginLeft: "10px",
                          color: "whitesmoke",
                        },
                      }}
                    />
                  )}
                  {open && (subMenuOpen.sale ? <ExpandLess /> : <ExpandMore />)}
                </ListItemButton>

                <Collapse in={subMenuOpen.sale} timeout="auto" unmountOnExit style={{ backgroundColor: 'rgba(76,175,80,0.25)' }}>
                  <List component="div" disablePadding>
                    <ListItemButton component={NavLink} to="/SaleRegister" sx={{ pl: 6, "&:hover": { bgcolor: "rgba(76,175,80,0.2)" } }}>
                      <ListItemText primary="Sale Register" primaryTypographyProps={{ style: { fontSize: "13px", fontFamily: "monospace", color: "whitesmoke", marginLeft: "5px" } }} />
                    </ListItemButton>
                    <ListItemButton component={NavLink} to="/Salegstreport" sx={{ pl: 6, "&:hover": { bgcolor: "rgba(76,175,80,0.2)" } }}>
                      <ListItemText primary="Sale GST Report" primaryTypographyProps={{ style: { fontSize: "13px", fontFamily: "monospace", color: "whitesmoke", marginLeft: "5px" } }} />
                    </ListItemButton>
                    <ListItemButton component={NavLink} to="/PartyandItemWiseReport" sx={{ pl: 6, "&:hover": { bgcolor: "rgba(76,175,80,0.2)" } }}>
                      <ListItemText primary="Sales Report" primaryTypographyProps={{ style: { fontSize: "13px", fontFamily: "monospace", color: "whitesmoke", marginLeft: "5px" } }} />
                    </ListItemButton>
                    <ListItemButton component={NavLink} to="/SaleAnalysisReport" sx={{ pl: 6, "&:hover": { bgcolor: "rgba(76,175,80,0.2)" } }}>
                      <ListItemText primary="Sale Analysis" primaryTypographyProps={{ style: { fontSize: "13px", fontFamily: "monospace", color: "whitesmoke", marginLeft: "5px" } }} />
                    </ListItemButton>
                    <ListItemButton component={NavLink} to="/DailySaleProfitReport" sx={{ pl: 6, "&:hover": { bgcolor: "rgba(76,175,80,0.2)" } }}>
                      <ListItemText primary="DSP" primaryTypographyProps={{ style: { fontSize: "13px", fontFamily: "monospace", color: "whitesmoke", marginLeft: "5px" } }} />
                    </ListItemButton>
                    <ListItemButton component={NavLink} to="/SaleHSNCReport" sx={{ pl: 6, "&:hover": { bgcolor: "rgba(76,175,80,0.2)" } }}>
                      <ListItemText primary="Sale HSNC" primaryTypographyProps={{ style: { fontSize: "13px", fontFamily: "monospace", color: "whitesmoke", marginLeft: "5px" } }} />
                    </ListItemButton>
                    <ListItemButton component={NavLink} to="/Stock" sx={{ pl: 6, "&:hover": { bgcolor: "rgba(76,175,80,0.2)" } }}>
                      <ListItemText primary="Stock" primaryTypographyProps={{ style: { fontSize: "13px", fontFamily: "monospace", color: "whitesmoke", marginLeft: "5px" } }} />
                    </ListItemButton>
                    <ListItemButton component={NavLink} to="/SalePaymentWise" sx={{ pl: 6, "&:hover": { bgcolor: "rgba(76,175,80,0.2)" } }}>
                      <ListItemText primary="Sale PaymentWise" primaryTypographyProps={{ style: { fontSize: "13px", fontFamily: "monospace", color: "whitesmoke", marginLeft: "5px" } }} />
                    </ListItemButton>
                  </List>
                </Collapse>

                {/* Stocks */}
                {/* <ListItemButton
                  onClick={() => toggleSubMenu("stocks")}
                  sx={{
                    pl: open ? 4 : 2,
                    bgcolor: subMenuOpen.stocks ? "rgba(33,150,243,0.15)" : "transparent",
                    "&:hover": { bgcolor: "rgba(33,150,243,0.25)" },
                  }}
                >

                  <ListItemIcon>
                    <ShowChartIcon sx={{ color: "whitesmoke", marginLeft: "20px", fontSize: '19px' }} />
                  </ListItemIcon>

                  {open && (
                    <ListItemText
                      primary="Stocks"
                      primaryTypographyProps={{
                        style: {
                          fontFamily: "monospace",
                          fontSize: "14px",
                          fontWeight: "bold",
                          marginLeft: "10px",
                          color: "whitesmoke",
                        },
                      }}
                    />
                  )}
                  {open && (subMenuOpen.stocks ? <ExpandLess /> : <ExpandMore />)}
                </ListItemButton>

                <Collapse in={subMenuOpen.stocks} timeout="auto" unmountOnExit style={{ backgroundColor: 'rgba(33,150,243,0.25)' }}>
                  <List component="div" disablePadding>
                    <ListItemButton component={NavLink} to="/StockRpt" sx={{ pl: 6, "&:hover": { bgcolor: "rgba(33,150,243,0.2)" } }}>
                      <ListItemText primary="Stock Report" primaryTypographyProps={{ style: { fontSize: "13px", fontFamily: "monospace", color: "whitesmoke", marginLeft: "5px" } }} />
                    </ListItemButton>
                    <ListItemButton component={NavLink} to="/StockDetailsReport" sx={{ pl: 6, "&:hover": { bgcolor: "rgba(33,150,243,0.2)" } }}>
                      <ListItemText primary="Stock Details" primaryTypographyProps={{ style: { fontSize: "13px", fontFamily: "monospace", color: "whitesmoke", marginLeft: "5px" } }} />
                    </ListItemButton>
                    <ListItemButton component={NavLink} to="/DeadStock" sx={{ pl: 6, "&:hover": { bgcolor: "rgba(33,150,243,0.2)" } }}>
                      <ListItemText primary="Dead Stock Report" primaryTypographyProps={{ style: { fontSize: "13px", fontFamily: "monospace", color: "whitesmoke", marginLeft: "5px" } }} />
                    </ListItemButton>
                  </List>
                </Collapse> */}

                {/* Accounts */}
                <ListItemButton
                  onClick={() => toggleSubMenu("accounts")}
                  sx={{
                    pl: open ? 4 : 2,
                    bgcolor: subMenuOpen.accounts ? "rgba(156,39,176,0.15)" : "transparent",
                    "&:hover": { bgcolor: "rgba(156,39,176,0.25)" },
                  }}
                >
                  <ListItemIcon>
                    <AccountBalanceWalletIcon sx={{ color: "whitesmoke", marginLeft: "20px", fontSize: '19px' }} />
                  </ListItemIcon>

                  {open && (
                    <ListItemText
                      primary="Accounts"
                      primaryTypographyProps={{
                        style: {
                          fontFamily: "monospace",
                          fontSize: "14px",
                          fontWeight: "bold",
                          marginLeft: "10px",
                          color: "whitesmoke",
                        },
                      }}
                    />
                  )}
                  {open && (subMenuOpen.accounts ? <ExpandLess /> : <ExpandMore />)}
                </ListItemButton>

                <Collapse in={subMenuOpen.accounts} timeout="auto" unmountOnExit style={{ backgroundColor: 'rgba(156,39,176,0.25)' }}>
                  <List component="div" disablePadding>
                    <ListItemButton component={NavLink} to="/CashBook" sx={{ pl: 6, "&:hover": { bgcolor: "rgba(156,39,176,0.2)" } }}>
                      <ListItemText primary="Cash Book" primaryTypographyProps={{ style: { fontSize: "13px", fontFamily: "monospace", color: "whitesmoke", marginLeft: "5px" } }} />
                    </ListItemButton>
                    <ListItemButton component={NavLink} to="/CreditorDebitorReport" sx={{ pl: 6, "&:hover": { bgcolor: "rgba(156,39,176,0.2)" } }}>
                      <ListItemText primary="Creditors/Debitors" primaryTypographyProps={{ style: { fontSize: "13px", fontFamily: "monospace", color: "whitesmoke", marginLeft: "5px" } }} />
                    </ListItemButton>
                    <ListItemButton component={NavLink} to="/CustomerOutstandingReport" sx={{ pl: 6, "&:hover": { bgcolor: "rgba(156,39,176,0.2)" } }}>
                      <ListItemText primary="Customer Outstanding" primaryTypographyProps={{ style: { fontSize: "13px", fontFamily: "monospace", color: "whitesmoke", marginLeft: "5px" } }} />
                    </ListItemButton>
                    <ListItemButton component={NavLink} to="/DailySaleProfitReport" sx={{ pl: 6, "&:hover": { bgcolor: "rgba(156,39,176,0.2)" } }}>
                      <ListItemText primary="Daily Sale Profit" primaryTypographyProps={{ style: { fontSize: "13px", fontFamily: "monospace", color: "whitesmoke", marginLeft: "5px" } }} />
                    </ListItemButton>
                    <ListItemButton component={NavLink} to="/Ledger" sx={{ pl: 6, "&:hover": { bgcolor: "rgba(156,39,176,0.2)" } }}>
                      <ListItemText primary="Ledger" primaryTypographyProps={{ style: { fontSize: "13px", fontFamily: "monospace", color: "whitesmoke", marginLeft: "5px" } }} />
                    </ListItemButton>
                    <ListItemButton component={NavLink} to="/SupplierOutstandingReport" sx={{ pl: 6, "&:hover": { bgcolor: "rgba(156,39,176,0.2)" } }}>
                      <ListItemText primary="Supplier Outstanding" primaryTypographyProps={{ style: { fontSize: "13px", fontFamily: "monospace", color: "whitesmoke", marginLeft: "5px" } }} />
                    </ListItemButton>
                    <ListItemButton component={NavLink} to="/TrialBalanceReport" sx={{ pl: 6, "&:hover": { bgcolor: "rgba(156,39,176,0.2)" } }}>
                      <ListItemText primary="Trial Balance" primaryTypographyProps={{ style: { fontSize: "13px", fontFamily: "monospace", color: "whitesmoke", marginLeft: "5px" } }} />
                    </ListItemButton>
                  </List>
                </Collapse>
              </List>
            </Collapse>
          </>
        )}

      </List>
    </Drawer>

  );
};

export default Sidebar;
